import React, { useEffect, useState } from "react";
import classes from "./GeneralBoard.module.scss";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeliveryBarChart from "../../components/DeliveryBarChart/DeliveryBarChart";
import EmailDataChart from "../../components/EmailDataChart/EmailDataChart";
import PerformanceDataChart from "../../components/PerformanceDataChart/PerformanceDataChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, CircularProgress, Grid, Paper } from "@mui/material";
import DataTableComponent from "../../components/DataTableComponent/DataTableComponent";
import icon1 from "../../assets/Images/icons/dashboardicon1.svg";
import icon2 from "../../assets/Images/icons/dashboardicon2.svg";
import icon3 from "../../assets/Images/icons/dashboardicon3.svg";
import icon4 from "../../assets/Images/icons/dashboardicon4.svg";
import ClientsGraph from "../../components/ClientsGraph/ClientsGraph";
import {
  getApprovedClientDetailsAPICall,
  getClientCountAPICall,
  getClientDetailsAPICall,
  getdashBoardIntroducerCommissiondayWiseGraphDataAPICall,
  getdashBoardRevenueGraphDataAPICall,
  getdashBoardRevenuedetailsAPICall,
} from "../../Utils/APICalls";
import RevenueGraph from "../../components/RevenueGraph/RevenueGraph";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DashBoardBottomLogo from "../../assets/Images/dashBoardBottomLogo.svg";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DoneIcon from "@mui/icons-material/Done";
import {
  FacebookShareButton,
  TwitterShareButton,
  RedditShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
// import { GetDashBoardDataAPICall } from "../../Utils/APICalls";

const monthmapping: any = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

const GeneralBoard = () => {
  const [bgColor, setbgColor] = useState("rgb(235, 231, 231)");
  const [dashBoardData, setDashboarddata] = useState({
    totalLeads: "0",
    openedAccounts: "0",
    unopenedAccounts: "0",
  });
  const [totalReward, setTotalReward] = useState({
    Month: 0,
    Reward: 0,
    Year: 0,
  });

  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentYear, setCurrentYear] = useState(new Date());
  const [year, setYear] = useState<number>();
  const [displayYearandMonth, setDisplayYearandMonth] = useState("");
  const [presentMonthAndYear, setPresentMonthandYear] = useState("");
  const [yearCheck, setYearCheck] = useState<number>();
  const userDetails: any = sessionStorage.getItem("userDetails");
  const Userdetails: any = JSON.parse(userDetails);
  const [loading, setLoading] = useState(false);
  const [revenueGraphData, setRevenueGraphData] = useState([]);
  const [tab, setTab] = useState(1);
  const [graphloading, setgraphloading] = useState(false);
  const [presentRevenue, setPresentRevenue] = useState<number>();
  const [timeLineMonth, setTimeLineMonth] = useState("");
  const [timeLineYear, setTimeLineYear] = useState<any>();
  const [copied, setCopied] = useState(false);
  const [approvedClientsCount, setApprovedClientsCount] = useState(0);
  const [pendingClientsCount, setPendingClientsCount] = useState(0);

  const [pYear, setpyear] = useState(new Date().getFullYear());

  const Day = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  function activeTab(tabNumber: any) {
    setTab(tabNumber);
  }

  useEffect(() => {
    setTotalReward({
      Month: 0,
      Reward: presentRevenue ? presentRevenue : 0,
      Year: 0,
    });
  }, [presentRevenue]);

  useEffect(() => {
    if (displayYearandMonth !== "") {
      getDashBoardCount();
    }

    if (displayYearandMonth !== presentMonthAndYear) {
      getDashBoardRevenueDetails();
    }
    if (displayYearandMonth !== "") {
      getDashBoardRevenueGraphData();
    }
  }, [displayYearandMonth]);

  const getDashBoardCount = () => {
    let obj: any = {
      month: displayYearandMonth,
    };
    getClientCountAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        setLoading(false);
        setDashboarddata(response.data.data[0]);
      })
      .catch((error: any) => {
        setLoading(false);
        // console.log("error", error);
      });
  };
  const getDashBoardRevenueDetails = () => {
    let obj: any = {
      month: displayYearandMonth,
    };
    setLoading(true);
    getdashBoardRevenuedetailsAPICall(obj)
      .then((response: any) => {
        setLoading(false);
        if (response.data.data) {
          setTotalReward(response.data.data);
        }

        // setDashboarddata(response.data.data[0]);
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const getDashBoardRevenueGraphData = () => {
    setgraphloading(true);
    let obj: any = {
      month: displayYearandMonth,
    };
    getdashBoardIntroducerCommissiondayWiseGraphDataAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        setgraphloading(false);
        if (response.data.data) {
          const newData = response.data.data.map((item: any, index: any) => ({
            ...item,
            date: Day[index], // Adjusted to start from 0 index
          }));
          const latest = response.data.data.every(
            (a: any) => a.Introducer_Commission === 0
          );

          // const poppedData = newData.pop();

          setRevenueGraphData(!latest ? newData : []);

          const totalAmount = response.data.data.reduce(
            (sum: any, item: any) => sum + item.Introducer_Commission,
            0
          );
          setPresentRevenue(totalAmount);
          if (displayYearandMonth === presentMonthAndYear) {
            sessionStorage.setItem("totalAmount", totalAmount);
          }
        } else {
          setRevenueGraphData([]);
          setPresentRevenue(0);
          sessionStorage.setItem("totalAmount", "0");
        }

        // setDashboarddata(response.data.data[0]);
      })
      .catch((error: any) => {
        setgraphloading(false);
        // console.log("error", error);
      });
  };

  useEffect(() => {
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      currentDate
    );
    const year = currentDate.getFullYear();
    const formattedDate = `${month} ${year}`;
    setPresentMonthandYear(formattedDate);
  }, []);

  useEffect(() => {
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      currentDate
    );
    const year = currentDate.getFullYear();
    const formattedDate = `${month} ${year}`;
    setTimeLineYear(year);
    setTimeLineMonth(month);
    setYearCheck(year);
    setDisplayYearandMonth(formattedDate);
  }, [currentDate]);

  useEffect(() => {
    const year = currentYear.getFullYear();
    setYear(year);
  }, [currentYear]);

  useEffect(() => {
    GetApprovedClientDetails();
    GetClientdetails();
  }, []);

  const GetApprovedClientDetails = () => {
    let obj: any = {
      page_no: 1,
      page_size: 20,
      filter_data: "",
    };
    getApprovedClientDetailsAPICall(obj)
      .then((response: any) => {
        setApprovedClientsCount(response.data.data.total_records);
      })
      .catch((error: any) => {});
  };

  const GetClientdetails = () => {
    let obj: any = {
      page_no: 1,
      page_size: 20,
      month: "all",
      approval_status: "pending",
      filter_data: "",
    };

    getClientDetailsAPICall(obj)
      .then((response: any) => {
        setPendingClientsCount(response.data.data.total_records);
      })
      .catch((error: any) => {});
  };

  const handlePreviousMonthClick = () => {
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() - 1);
    setCurrentDate(previousMonth);
  };
  const handlePreviousYearClick = () => {
    setYear((previous: any) => previous - 1);
  };
  const handleNextYearClick = () => {
    setYear((previous: any) => previous + 1);
  };
  const handleNextMonthClick = () => {
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() + 1);
    setCurrentDate(previousMonth);
  };
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    currentDate
  );
  const newmonth = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    new Date()
  );
  const presentYear = currentDate.getFullYear();
  const yearNow = new Date().getFullYear();

  function calculatePercentage(part: any, total: any) {
    if (total === 0) {
      return 0; // To avoid division by zero
    }
    const percentage = (part / total) * 100;
    return percentage.toFixed(2); // Round to two decimal places
  }

  const percentageAccountOpened = calculatePercentage(
    approvedClientsCount,
    approvedClientsCount + pendingClientsCount
  );
  const percentageInProcess = calculatePercentage(
    pendingClientsCount,
    approvedClientsCount + pendingClientsCount
  );
  // const percentageAccountOpened = calculatePercentage(
  //   dashBoardData.openedAccounts,
  //   dashBoardData.totalLeads
  // );
  // const percentageInProcess = calculatePercentage(
  //   dashBoardData.unopenedAccounts,
  //   dashBoardData.totalLeads
  // );

  const getWeekendDates = (year: any, month: any) => {
    const weekendDays: any = { Saturdays: [], Sundays: [] };
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);

    for (let day = firstDay; day <= lastDay; day.setDate(day.getDate() + 1)) {
      if (day.getDay() === 0) {
        weekendDays.Sundays.push(day.getDate());
      } else if (day.getDay() === 6) {
        weekendDays.Saturdays.push(day.getDate());
      }
    }

    return weekendDays;
  };

  const { Saturdays, Sundays } = getWeekendDates(
    timeLineYear,
    monthmapping[timeLineMonth]
  );

  return (
    <>
      <div className={classes.mainWrapper}>
        <div className={classes.leftContainer}>
          <div className={classes.leftContainerTopTitle}>
            {/* <p className={classes.welcomeText}>
              Welcome {UserDetails ? UserDetails.Name : ""}
            </p> */}
            <p className={classes.dashboardText}>Dashboard</p>
            <div className={classes.nextTopPreviousSection}>
              <div
                className={classes.topprevious}
                onClick={handlePreviousMonthClick}
              >
                <KeyboardArrowLeftIcon />
              </div>
              <div className={classes.topyearText}>{displayYearandMonth}</div>
              <div
                className={classes.topnext}
                onClick={() => {
                  if (month !== newmonth || presentYear !== yearNow) {
                    handleNextMonthClick();
                  }
                }}
                style={{
                  background:
                    month === newmonth && presentYear === yearNow ? "grey" : "",
                }}
              >
                <KeyboardArrowRightIcon />
              </div>
            </div>
          </div>
          <div className={classes.cardsSection}>
            <p className={classes.SummaryText}>Summary</p>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={3}>
                  <div className={classes.data1}>
                    <img src={icon1} className={classes.icon} />
                    <div className={classes.dataTitle}>
                      {" "}
                      {loading ? (
                        <CircularProgress
                          size={18}
                          sx={{ marginLeft: "10px" }}
                        />
                      ) : (
                        `₹${Math.floor(
                          parseFloat(totalReward.Reward.toString())
                        )}`
                      )}
                    </div>
                    <div className={classes.dataInfo}>
                      <p className={classes.dataInfoHeader}>Total Reward</p>
                      {/* <p className={classes.dataInfoSubText}>
                        +8% from yesterday
                      </p> */}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div className={classes.data1}>
                    <img src={icon2} className={classes.icon} />
                    <div className={classes.dataTitle}>
                      {loading ? (
                        <CircularProgress
                          size={18}
                          sx={{ marginLeft: "10px" }}
                        />
                      ) : (
                        `${dashBoardData.totalLeads}`
                      )}
                    </div>
                    <div className={classes.dataInfo}>
                      <p className={classes.dataInfoHeader}>Total Leads</p>
                      {/* <p className={classes.dataInfoSubText}>
                        +8% from yesterday
                      </p> */}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div className={classes.data1}>
                    <img src={icon3} className={classes.icon} />
                    <div className={classes.dataTitle}>
                      {loading ? (
                        <CircularProgress
                          size={18}
                          sx={{ marginLeft: "10px" }}
                        />
                      ) : (
                        `${dashBoardData.openedAccounts}`
                      )}
                    </div>
                    <div className={classes.dataInfo}>
                      <p className={classes.dataInfoHeader}>Total Conversion</p>
                      {/* <p className={classes.dataInfoSubText}>
                        +8% from yesterday
                      </p> */}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div className={classes.data1}>
                    <img src={icon4} className={classes.icon} />
                    <div className={classes.dataTitle}>
                      {loading ? (
                        <CircularProgress
                          size={18}
                          sx={{ marginLeft: "10px" }}
                        />
                      ) : (
                        `${dashBoardData.unopenedAccounts}`
                      )}
                    </div>
                    <div className={classes.dataInfo}>
                      <p className={classes.dataInfoHeader}>In Progress</p>
                      {/* <p className={classes.dataInfoSubText}>
                        0.5% from yesterday
                      </p> */}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
          <div className={classes.revenueGraph}>
            <p className={classes.revenueText}>Revenue Generated</p>
            <div className={classes.revenueGraphSection}>
              {/* <div className={classes.buttonSection}>
                <div className={classes.nextPreviousSection}>
                  <div
                    className={classes.previous}
                    onClick={handlePreviousYearClick}
                  >
                    <KeyboardArrowLeftIcon />
                  </div>
                  <div className={classes.yearText}>{year}</div>
                  <div
                    className={classes.next}
                    onClick={() => {
                      if (presentYear !== year) {
                        handleNextYearClick();
                      }
                    }}
                    style={{ background: presentYear === year ? "grey" : "" }}
                  >
                    <KeyboardArrowRightIcon />
                  </div>
                </div>
              </div> */}
              <div className={classes.revenueGraphChart}>
                <RevenueGraph
                  revenueGraphData={revenueGraphData}
                  loading={graphloading}
                  Saturdays={Saturdays}
                  Sundays={Sundays}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.rightContainerGraph}>
            <ClientsGraph
              opened={percentageAccountOpened}
              inProcess={percentageInProcess}
              pendingClientsCount={pendingClientsCount}
              approvedClientsCount={approvedClientsCount}
            />
          </div>
          <div className={classes.profileContainer}>
            <p className={classes.profileContainerheader}>
              <span>Your Referral Link</span>{" "}
              <InsertLinkIcon
                sx={{ transform: "rotate(135deg)", color: "#006779" }}
              />
            </p>
            <p className={classes.profileContainerSubText}>
              https://signup.firstock.in?p=
              {Userdetails ? Userdetails.IntroducerCode : ""}
            </p>
            <div style={{ width: "90%" }}>
              <CopyToClipboard
                text={`https://signup.firstock.in?p=${
                  Userdetails ? Userdetails.IntroducerCode : ""
                }`}
                onCopy={() => {
                  setCopied(true);

                  setTimeout(() => {
                    setCopied(false);
                  }, 4000);
                }}
              >
                <Button
                  // onClick={handleClickOpen}
                  fullWidth
                  variant="outlined"
                  sx={{
                    borderColor: "rgba(0, 103, 121, 1)",
                    backgroundColor: "rgba(0, 103, 121, 1)",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    padding: "8px 50px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "12px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 103, 121, 1)",
                      borderColor: "rgba(0, 103, 121, 1)",
                      color: "white",
                    },
                  }}
                  startIcon={copied ? <DoneIcon /> : <ContentCopyIcon />}
                >
                  {" "}
                  Copy Link
                </Button>
              </CopyToClipboard>
            </div>
            <div style={{ width: "90%" }}>
              <WhatsappShareButton
                url={`https://signup.firstock.in?p=${
                  Userdetails ? Userdetails.IntroducerCode : ""
                }`}
                style={{ width: "100%" }}
              >
                <Button
                  // onClick={handleClickOpen}
                  fullWidth
                  variant="outlined"
                  sx={{
                    borderColor: "#00C800",
                    backgroundColor: "#00C800",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    marginTop: "10px",
                    padding: "8px 10px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "12px",
                    "&:hover": {
                      backgroundColor: "#00C800",
                      borderColor: "#00C800",
                      color: "white",
                    },
                  }}
                  startIcon={<WhatsAppIcon />}
                >
                  {" "}
                  Share on WhatsApp
                </Button>
              </WhatsappShareButton>
            </div>
          </div>
        </div>
      </div>
      {/* <Box sx={{ flexGrow: 1 }} mb={4}>
        <div className={classes.deliveryTitle}>
          <h3>Delivery</h3>
        </div>
        <Grid container>
          <Grid item xs={6} md={3}>
            <div
              className={classes.deliveryGraph}
              // onMouseEnter={() => {
              //   setbgColor("#8055DA");

              // }}
              // onMouseLeave={() => {
              //   setbgColor("rgb(235, 231, 231)");
              // }}
            >
              <div className={classes.dgTitle}>
                <h4>Delivered Rate</h4>

                <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
              </div>
              <div className={classes.dgRate}>89%</div>
              <div className={classes.dgInfo}>38 delivered</div>
              <div className={classes.dgPlot}>
                <DeliveryBarChart bgColor={bgColor} />
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className={classes.deliveryGraph}>
              <div className={classes.dgTitle}>
                <h4>Unsubscribed Rate</h4>

                <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
              </div>
              <div className={classes.dgRate}>89%</div>
              <div className={classes.dgInfo}>38 delivered</div>
              <div className={classes.dgPlot}>
                <DeliveryBarChart bgColor={bgColor} />
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className={classes.deliveryGraph}>
              <div className={classes.dgTitle}>
                <h4>Hard Bounce Rate</h4>

                <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
              </div>
              <div className={classes.dgRate}>89%</div>
              <div className={classes.dgInfo}>38 delivered</div>
              <div className={classes.dgPlot}>
                <DeliveryBarChart bgColor={bgColor} />
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className={classes.deliveryGraph1}>
              <div className={classes.dgTitle}>
                <h4>Spam report Rate</h4>
                <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
              </div>
              <div className={classes.dgRate}>89%</div>
              <div className={classes.dgInfo}>38 delivered</div>
              <div className={classes.dgPlot}>
                <DeliveryBarChart bgColor={bgColor} />
              </div>
            </div>
          </Grid>
        </Grid>
      </Box> */}

      {/* <Box sx={{ flexGrow: 1 }} mb={4}>
        <Grid container>
          <Grid item xs={6} md={6}>
            <div className={classes.emailData}>
              <div className={classes.edTitle}>Email Data Chart</div>
              <div className={classes.edDatakey}>
                <div className={classes.edDatakey1}>
                  {" "}
                  <div className={classes.edDatakeyCircle1}></div>{" "}
                  <div className={classes.edDatakeyTitle}>
                    Click through rate
                  </div>
                </div>
                <div className={classes.edDatakey2}>
                  {" "}
                  <div className={classes.edDatakeyCircle2}></div>{" "}
                  <div className={classes.edDatakeyTitle}>Open rate</div>
                </div>
              </div>
              <div className={classes.edPlot}>
                <EmailDataChart />
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={6}>
            <div className={classes.performanceData}>
              <div className={classes.pdTitle}>Performance By Device Type</div>
              <div className={classes.edDatakey}>
                <div className={classes.edDatakey1}>
                  {" "}
                  <div className={classes.edDatakeyCircle1}></div>{" "}
                  <div className={classes.edDatakeyTitle}>
                    Click through rate
                  </div>
                </div>
                <div className={classes.edDatakey2}>
                  {" "}
                  <div className={classes.edDatakeyCircle2}></div>{" "}
                  <div className={classes.edDatakeyTitle}>Open rate</div>
                </div>
              </div>
              <div className={classes.edPlot}>
                <PerformanceDataChart />
              </div>
            </div>
          </Grid>
        </Grid>
      </Box> */}
    </>
  );
};

export default GeneralBoard;
